import { useEffect, useState } from "react";
import { Player } from "../api/types.tsx";
import { playerService } from "../api/service.ts";
import dayjs from "dayjs";

export function usePlayerSelection() {
    const [players, setPlayers] = useState<Player[]>([]);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [detailPlayer, setDetailPlayer] = useState<Player | null>(null);
    const [openCompareDialog, setOpenCompareDialog] = useState(false);
    const [openCertificateDialog, setOpenCertificateDialog] = useState(false);
    const [selectedPlayer, setSelectedPlayer] = useState<Player | null>(null);
    const [newDate, setNewDate] = useState<string>("");

    const numericFields: (keyof Player)[] = [
        "attack", "defense", "serve", "wall", "setting", "personality", "seniority", "baseSkill", "skill", "presence",
    ];

    useEffect(() => {
        refreshPlayers();
    }, []);

    const refreshPlayers = () =>
        playerService.getPlayers().then(setPlayers).catch((e) => {
            console.error("Errore caricamento players", e);
            setPlayers([]);
        });

    const togglePlayer = (id: number) =>
        setSelectedIds((prev) => (prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id]));

    const initials = (p: Player) => {
        const name = p.nickname || `${p.firstName} ${p.lastName}`.trim();
        return name.split(" ").map((s) => s.charAt(0)).slice(0, 2).join("").toUpperCase();
    };

    const maxValues: Partial<Record<keyof Player, number>> = {};
    numericFields.forEach((field) => {
        maxValues[field] = Math.max(
            ...players.filter((p) => selectedIds.includes(p.id)).map((p) => p[field] as number)
        );
    });

    const topPlayers = [...players]
        .filter((p) => p.dynamicStats?.form !== undefined)
        .sort((a, b) => (b.dynamicStats?.form || 0) - (a.dynamicStats?.form || 0))
        .slice(0, 3)
        .map((p) => p.id);

    const openCertificateEdit = (p: Player) => {
        const current = p.suitabilityCertificate ? new Date(p.suitabilityCertificate) : new Date();
        const defaultNewDate = new Date(current);
        defaultNewDate.setFullYear(defaultNewDate.getFullYear() + 1);
        setSelectedPlayer(p);
        setNewDate(dayjs(defaultNewDate).format("YYYY-MM-DD"));
        setOpenCertificateDialog(true);
    };

    const saveCertificate = async () => {
        if (selectedPlayer && newDate) {
            await playerService.updatePlayerCertificate(selectedPlayer.id, newDate);
            setOpenCertificateDialog(false);
            refreshPlayers();
        }
    };

    return {
        players,
        selectedIds,
        setSelectedIds,
        numericFields,
        togglePlayer,
        refreshPlayers,
        initials,
        maxValues,
        topPlayers,
        detailPlayer,
        setDetailPlayer,
        openCompareDialog,
        setOpenCompareDialog,
        openCertificateDialog,
        setOpenCertificateDialog,
        selectedPlayer,
        newDate,
        setNewDate,
        openCertificateEdit,
        saveCertificate,
    };
}
